export class ChartColors {
    backgroundColor: string[] = [];
    borderColor: string[] = [];
    borderWidth: number = 2;
}
